import styled from "styled-components";
import {VouchersGamesListTitleDefaultBox} from "./voucher-games-list-title.default.box";

export const VouchersGamesListTitleSIBox = styled(VouchersGamesListTitleDefaultBox)`
    ${({theme}) => theme.font.presets.thin}
`;
